import { Box, InputLabel, NativeSelect } from '@mui/material';
import { type ChangeEvent, useCallback } from 'react';

type DropdownProps = {
  id: string;
  value: string;
  label?: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  disabled?: boolean;
};

export function Dropdown({ id, value, label, options, onChange, disabled }: DropdownProps) {
  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      const value = event.target.value;
      onChange(value);
    },
    [onChange],
  );

  return (
    <Box>
      {label && (
        <InputLabel htmlFor={id} shrink={false} sx={{ color: 'common.black', mb: 1 }}>
          {label}
        </InputLabel>
      )}

      <NativeSelect
        variant="filled"
        value={value}
        onChange={handleOnChange}
        inputProps={{ name: 'dropdown', id }}
        disableUnderline
        sx={({ palette }) => ({
          border: '1px solid',
          borderColor: 'neutral.dark',
          borderRadius: '.125rem',
          width: { xs: '100%', sm: 'auto' },

          '&:hover': {
            backgroundColor: 'neutral.lightest',
          },

          '&.Mui-focused': {
            borderColor: 'blue.light',
            boxShadow: `0 0 0 .05rem ${palette.blues.light}`,
            backgroundColor: 'blue.lightest',
          },

          '.MuiNativeSelect-select': {
            padding: '.5rem 1rem',
          },

          '.MuiNativeSelect-icon': {
            height: '1.5rem',
            width: '1.5rem',
            top: 'calc(50% - .75rem)',
          },
        })}
        disabled={disabled}
      >
        {options.map((option, index) => {
          return (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </NativeSelect>
    </Box>
  );
}
